// extracted by mini-css-extract-plugin
module.exports = {"container":"QuotePage_container__2_bh5"};